import React, { useEffect, useState } from 'react'
import { GlobalDataState } from '../../Context';
import { AiFillStar } from 'react-icons/ai';
import "./MovieDetailsPage.css"
import Actors from './Actors';
import Videos from './Videos';
import Recommendation from './Recommendation';
import SearchAll from '../SearchAll';
const MovieDetailsPage = () => {
    const {clickedId}=GlobalDataState();
   // console.log(clickedId)
   const [info,setInfo]=useState({});
    useEffect(()=>{
       getInfo();  
    },[clickedId])


    const {
        state:{stack},
        dispatch,
    }=GlobalDataState();


    async function getInfo(){
        const data=await fetch(`https://api.themoviedb.org/3/movie/${clickedId}?api_key=95827c3fee6b7922a023ac65e529dca2&language=en-US`)
        const json=await data.json();
        //console.log(json)
        setInfo(json)
    }
  return (
    
    <div>
        <SearchAll/>
        {
            //Object.values(info).map((idx)=>(
                <div style={{marginTop:"1rem"}}>
                <img className='BannerM' src={`https://image.tmdb.org/t/p/w500/${info.backdrop_path}`}></img>
                {/* <img className='Banner' src={`https://image.tmdb.org/t/p/w500/m1fgGSLK0WvRpzM1AmZu38m0Tx8.jpg`}></img> */}
                <div>
                        <div>
                            <img className='poster' src={`https://image.tmdb.org/t/p/w500/${info.poster_path}`}></img>
                            {/* <img className='poster' src={`https://image.tmdb.org/t/p/w500/gbGHezV6yrhua0KfAgwrknSOiIY.jpg`}></img> */}
                        </div>
                        <div className='title'>{info.title}</div>
                        {/* <div className='title'>Supercell</div> */}
                        <div className='rating'><AiFillStar/>{info.vote_average}</div>
                        {/* <div className='rating'><AiFillStar/>{7.8}</div> */}
                        <div className='desc'>
                            <h4>Overview</h4>
                            <p>{info.overview}</p>
                        </div>
                        <div style={{marginLeft:"40rem"}}>
                            <div style={{display:'flex'}}> 
                            <button onClick={()=>dispatch({type:"ADD_TO_STORE",payload:info,})} style={{borderRadius:"1rem",backgroundColor:"#16FF00",width:'4rem',height:'3rem'}}>ADD</button>
                            <button onClick={()=>dispatch({type:"REMOVE_FROM_STORE",payload:info,})} style={{borderRadius:"1rem",backgroundColor:"#FF0303",width:'6rem',marginLeft:'5rem'}}>REMOVE</button>
                            </div>
                        </div>
                    </div>
                </div>
            //))
        }

        {
            // console.log(info.id)
        
         <div className='Actors'>
            <h2 style={{marginLeft:'1rem',marginTop:'2rem'}}>Cast</h2>
            <Actors id={info.id}/>
        </div>

        } 
        <div className='video'>
        <h2 >Trailer</h2>
            <Videos id={info.id}/>
        </div>
         <div>
            <Recommendation id={info.id}/>
        </div> 
    </div>
  )
}

export default MovieDetailsPage